module.exports = __webpack_public_path__ + "public/SiteIcons/double-quotes.png?811f2c4d";